/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Warm_Fox_DashInputs */

const en_soft_warm_fox_dash = /** @type {(inputs: Soft_Warm_Fox_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comma-separated round IDs`)
};

const de_soft_warm_fox_dash = /** @type {(inputs: Soft_Warm_Fox_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommagetrennte Runden-IDs`)
};

/**
* | output |
* | --- |
* | "Comma-separated round IDs" |
*
* @param {Soft_Warm_Fox_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_warm_fox_dash = /** @type {((inputs?: Soft_Warm_Fox_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Warm_Fox_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_warm_fox_dash(inputs)
	return de_soft_warm_fox_dash(inputs)
});